export const openingHoursSection = "/opening-hours/";

export const openingHoursUrl = () => openingHoursSection;
